import Vue from 'vue';
import global_mixin from './global_mixins.js'
import '../css/secondary_page.css'
import HTMLBlock1 from '../components/HTMLBlock1.vue'

Vue.component('html-block-1', HTMLBlock1)

const app = new Vue({
  el: '#app',
  data () {
    return {
    }
  },
  mixins: [global_mixin]
})


// WEBPACK FOOTER //
// ./core/vue/js/secondary_page.js